import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { clientApi, Pack } from '@/api/client'
import { getDefaultWatchlistId } from '@/auth/session'
import Loading from '@/components/Loading'
import ErrorBox from '@/components/ErrorBox'
import Topbar from '@/components/Topbar'

export default function Packs() {
  const nav = useNavigate()
  const [packs, setPacks] = useState<Pack[] | null>(null)
  const [selected, setSelected] = useState<Record<string, boolean>>({})
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<any>(null)

  useEffect(() => {
    let cancelled = false
    clientApi.packs().then((p) => {
      if (cancelled) return
      setPacks(p)
      const init: Record<string, boolean> = {}
      for (const x of p.slice(0, 2)) init[x.pack_id] = true
      setSelected(init)
    }).catch(setError)
    return () => { cancelled = true }
  }, [])

  const chosen = useMemo(() => Object.keys(selected).filter((k) => selected[k]), [selected])

  async function apply() {
    setBusy(true)
    setError(null)
    try {
      const res = await clientApi.selectPacks(chosen)
      const wid = res?.watchlist_id || getDefaultWatchlistId()
      if (wid) nav(`/watchlists/${wid}`)
      else nav('/watchlists')
    } catch (e) {
      setError(e)
    } finally {
      setBusy(false)
    }
  }

  if (!packs && !error) return <div className="container"><Loading label="Loading packs" /></div>

  return (
    <div className="container">
      <Topbar
        subtitle="Select packs"
        right={
          <button className="btn primary" onClick={apply} disabled={busy || chosen.length === 0}>
            Create watchlist
          </button>
        }
      />

      <div className="grid">
        <div className="card">
          <h2>Packs</h2>
          <div className="muted">Choose a couple packs to seed your default watchlist.</div>
          <div style={{ height: 10 }} />
          <div className="tableWrap">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: 44 }}></th>
                  <th>Name</th>
                  <th>Kind</th>
                  <th>Visibility</th>
                </tr>
              </thead>
              <tbody>
                {(packs || []).map((p) => (
                  <tr key={p.pack_id}>
                    <td>
                      <input
                        className="check"
                        type="checkbox"
                        checked={!!selected[p.pack_id]}
                        onChange={(e) => setSelected({ ...selected, [p.pack_id]: e.target.checked })}
                      />
                    </td>
                    <td>
                      <div style={{ fontWeight: 650 }}>{p.name}</div>
                      <div className="muted">{p.description || ''}</div>
                      <div className="mono muted" style={{ marginTop: 6, fontSize: 12 }}>{p.pack_id}</div>
                    </td>
                    <td><span className="pill">{p.kind}</span></td>
                    <td>{p.is_public ? <span className="pill ok">Public</span> : <span className="pill">Private</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {error ? <ErrorBox error={error} /> : null}
      </div>
    </div>
  )
}
